/** @jsx jsx */

import { SkeletonLoader, SkeletonText, Spacer } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    padding: 20px 0;
  `,
};

const PublishingLoader = () => {
  return (
    <SkeletonLoader>
      <section css={Styles.root}>
        <SkeletonText lines={2} size="body" />
        <Spacer height={20} />
      </section>
    </SkeletonLoader>
  );
};

export default PublishingLoader;
